<template>
  <el-row :gutter="24" type="flex" style="flex-wrap: wrap;">
    <el-col
      :xs="12"
      :sm="12"
      :md="8"
      :lg="6"
      v-for="(item, index) in imgList"
      :key="index"
      class="card-wrap"
    >
      <div class="img-text-card">
        <!-- 图片区域 -->
        <div class="img-box">
          <img :src="item.img" :alt="item.text" loading="lazy" />
          <!-- 图片底部微光渐变层，增加层次 -->
          <div class="img-overlay-glow"></div>
        </div>

        <!-- 文字区域 -->
        <div class="text-wrap">
          <div class="title-text">
            <span class="serial-num">{{ index + 1 }}</span>
            <span class="title-desc">{{ item.text }}</span>
          </div>
          <!-- 装饰性小分隔点 -->
          <span class="dot-divider"></span>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: "SImgNum",
  props: {
    imgList: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
// ===== 主题变量 =====
$primary-start: #5aa8ff;
$primary-end: #1d6fe0;
$primary-gradient: linear-gradient(135deg, $primary-start 0%, $primary-end 100%);
$card-radius: 16px;
$text-dark: #1a2639;
$text-soft: #3d4e66;
$shadow-card: 0 8px 24px rgba(0, 20, 50, 0.06), 0 2px 6px rgba(0, 0, 0, 0.02);
$shadow-hover: 0 20px 44px rgba(29, 111, 224, 0.16), 0 8px 20px rgba(0, 0, 0, 0.04);
$border-light: rgba(29, 111, 224, 0.10);

.card-wrap {
  margin-bottom: 28px;
  transition: all 0.2s ease;

  // 卡片容器 —— 增加立体层次
  .img-text-card {
    width: 100%;
    border-radius: $card-radius;
    background: #ffffff;
    box-shadow: $shadow-card;
    transition: all 0.35s cubic-bezier(0.2, 0.8, 0.2, 1);
    overflow: hidden;
    border: 1px solid rgba(255, 255, 255, 0.5);
    backdrop-filter: blur(2px);

    // 悬浮效果 —— 提升层次感
    &:hover {
      transform: translateY(-8px) scale(1.01);
      box-shadow: $shadow-hover;
      border-color: rgba(90, 168, 255, 0.25);

      .img-box img {
        transform: scale(1.06);
      }

      .serial-num {
        box-shadow: 0 6px 18px rgba(29, 111, 224, 0.40);
        transform: scale(1.05);
      }

      .img-overlay-glow {
        opacity: 0.6;
      }
    }

    // ----- 图片容器 -----
    .img-box {
      position: relative;
      width: 100%;
      height: 13.5vw;
      min-height: 110px;
      max-height: 200px;
      overflow: hidden;
      background: #eef3fa;
      border-bottom: 2px solid rgba(29, 111, 224, 0.06);

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.6s cubic-bezier(0.2, 0.8, 0.2, 1);
        display: block;
      }

      // 底部微光渐变 —— 增加层次感
      .img-overlay-glow {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 40%;
        background: linear-gradient(to top, rgba(29, 111, 224, 0.08), transparent);
        pointer-events: none;
        opacity: 0;
        transition: opacity 0.4s ease;
      }

      // 内置高光线 (模拟内阴影)
      &::after {
        content: "";
        position: absolute;
        inset: 0;
        border-radius: $card-radius $card-radius 0 0;
        box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.5);
        pointer-events: none;
      }
    }

    // ----- 文字区域 -----
    .text-wrap {
      padding: 16px 12px 18px;
      text-align: center;
      position: relative;
      background: linear-gradient(180deg, #ffffff 0%, #f9fcff 100%);

      .title-text {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-size: 15px;
        font-weight: 500;
        color: $text-dark;
        line-height: 1.5;
        letter-spacing: 0.4px;

        .serial-num {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 28px;
          height: 28px;
          margin-right: 10px;
          color: #fff;
          font-size: 14px;
          font-weight: 600;
          background: $primary-gradient;
          border-radius: 50%;
          box-shadow: 0 4px 12px rgba(29, 111, 224, 0.30);
          flex-shrink: 0;
          transition: all 0.3s ease;
          letter-spacing: 0;
        }

        .title-desc {
          color: $text-dark;
          font-weight: 500;
          position: relative;

          // 文字底部装饰线 (悬浮时出现)
          &::after {
            content: "";
            position: absolute;
            bottom: -3px;
            left: 0;
            width: 0;
            height: 2px;
            background: $primary-gradient;
            border-radius: 2px;
            transition: width 0.3s ease;
          }
        }
      }

      // 小装饰点 (增加细节层次)
      .dot-divider {
        display: block;
        width: 24px;
        height: 2px;
        margin: 10px auto 0;
        background: linear-gradient(90deg, transparent, rgba(29, 111, 224, 0.20), transparent);
        border-radius: 2px;
        transition: all 0.3s ease;
      }
    }

    // 悬浮时文字下划线出现
    &:hover .title-desc::after {
      width: 100%;
    }

    &:hover .dot-divider {
      background: linear-gradient(90deg, transparent, $primary-start, transparent);
      width: 40px;
    }
  }
}

// ===== 响应式 =====

/* 平板 */
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .card-wrap .img-text-card .img-box {
    height: 18vw;
    min-height: 100px;
  }

  .card-wrap .img-text-card .text-wrap .title-text {
    font-size: 14px;
  }

  .card-wrap .img-text-card .text-wrap {
    padding: 14px 10px 16px;
  }
}

/* 手机 */
@media only screen and (max-width: 767px) {
  .card-wrap {
    margin-bottom: 18px;
  }

  .card-wrap .img-text-card .img-box {
    height: 28vw;
    min-height: 80px;
    border-radius: 12px 12px 0 0;
  }

  .card-wrap .img-text-card .text-wrap {
    padding: 12px 8px 14px;

    .title-text {
      font-size: 13px;
      letter-spacing: 0;

      .serial-num {
        width: 24px;
        height: 24px;
        font-size: 12px;
        margin-right: 8px;
      }
    }

    .dot-divider {
      width: 18px;
      margin-top: 8px;
    }
  }

  .card-wrap .img-text-card:hover {
    transform: translateY(-4px) scale(1.01);
  }
}

/* 大屏适配（>1400px） */
@media only screen and (min-width: 1400px) {
  .card-wrap .img-text-card .img-box {
    height: 12vw;
    max-height: 220px;
  }
}

// 栅格内边距修复 (适配 el-row 的 gutter)
.el-row {
  margin-left: -12px !important;
  margin-right: -12px !important;
}
.el-col {
  padding-left: 12px !important;
  padding-right: 12px !important;
}
</style>